import type { AmountImpact, BoqRow, DiffStatus } from '../../types'

export function calculateAmountImpact(
  baselineRow: BoqRow | null,
  targetRow: BoqRow | null,
  status: DiffStatus,
): AmountImpact {
  const baselineEffectiveTotal = baselineRow?.effectiveTotalPrice ?? null
  const targetEffectiveTotal = targetRow?.effectiveTotalPrice ?? null

  let value: number | null = null
  if (baselineRow === null && targetRow !== null) value = targetEffectiveTotal
  else if (baselineRow !== null && targetRow === null) {
    value = baselineEffectiveTotal === null ? null : -baselineEffectiveTotal
  } else if (baselineRow !== null && targetRow !== null) {
    value =
      baselineEffectiveTotal !== null && targetEffectiveTotal !== null
        ? targetEffectiveTotal - baselineEffectiveTotal
        : null
  }

  if (status === 'pending') {
    return {
      value,
      state: 'pending',
      includedInConfirmedTotal: false,
      baselineEffectiveTotal,
      targetEffectiveTotal,
      reason: value === null ? '待确认且缺少有效合价' : '待确认金额，不计入已确认净影响',
    }
  }
  if (value === null) {
    return {
      value: null,
      state: 'unavailable',
      includedInConfirmedTotal: false,
      baselineEffectiveTotal,
      targetEffectiveTotal,
      reason: '缺少计算金额影响所需的有效合价',
    }
  }
  return {
    value,
    state: 'confirmed',
    includedInConfirmedTotal: true,
    baselineEffectiveTotal,
    targetEffectiveTotal,
    reason: '按对比版有效合价减基准版有效合价计算',
  }
}

export function createEmptyAmountImpact(): AmountImpact {
  return {
    value: null,
    state: 'unavailable',
    includedInConfirmedTotal: false,
    baselineEffectiveTotal: null,
    targetEffectiveTotal: null,
    reason: '尚未计算',
  }
}
